import { jackPotStore } from '../../store/jackPotStore';
import {jackpotConnection} from "../socketConnection/jackpotConnection";
import {boostedJackpotStore} from "../../store/boostedJackpotStore";

class JackpotService {
  handleJackpotResult(data) {
    jackPotStore.setJackpotAmounts(data);
  }

  handleJackpotWin(data) {
    jackPotStore.setJackpotWinInfo(data);
  }

  handleJackpotWinnerInfoResult(data) {
    jackPotStore.setJackpotWinnerInfo(data);
  }

  handleBoostedJackpotWinnerInfoResult(data) {
    const {
      winAmount,
      leftWinsCount,
      leftPoolSize,
      lastWin,
      lastWinDate,
      largestWin,
      largestWinDate,
    } = data;
    const {
      setLastWinnerDate,
      setWinningCountLeft,
      setLastWinnerAmount,
      setLargestWinnerDate,
      setLargestWinnerAmount,
      setPrizePoolLeftAmount,
      setPlayerBoostedWinAmount,
    } = boostedJackpotStore;

    setLastWinnerAmount(lastWin);
    setLastWinnerDate(lastWinDate);
    setLargestWinnerAmount(largestWin);
    setWinningCountLeft(leftWinsCount);
    setLargestWinnerDate(largestWinDate);
    setPrizePoolLeftAmount(leftPoolSize);
    setPlayerBoostedWinAmount(winAmount);
  }

  handleReconnected(){
    jackpotConnection.sendGameGetInitialState(false)
  }
}

export const jackpotService = new JackpotService();
